import React from 'react';
import { ActiveScreenType } from '../../common/administrationItemsLib';
import NoEntityListSelected from '../components/NoEntityListSelected';
import EntityListItemsSection from './detail/EntityListItemsSection';
import EntityListEditModeSection from './edit/EntityListEditModeSection';
import { EntityListTypeSupported } from '../entityListsLib';
import { useCurrentEntityListState } from '../hooks/useCurrentEntityListState';

interface EntityListAdministrationContentProps {
  entityListType: EntityListTypeSupported;
}

const EntityListAdministrationContent: React.FC<EntityListAdministrationContentProps> = ({
  entityListType,
}) => {
  const entityListState = useCurrentEntityListState(entityListType);

  switch (entityListState?.activeScreenType) {
    case ActiveScreenType.NO_SELECTION:
      return <NoEntityListSelected entityListType={entityListType} />;
    case ActiveScreenType.DETAIL:
      return <EntityListItemsSection entityListType={entityListType} />;
    case ActiveScreenType.EDIT:
      return <EntityListEditModeSection entityListType={entityListType} />;
    case ActiveScreenType.VALIDATION:
      return 'Not implemented!';
    case ActiveScreenType.DONE:
      return null;
    case undefined:
      return <NoEntityListSelected entityListType={entityListType} />;
    default:
      return <NoEntityListSelected entityListType={entityListType} />;
  }
};

export default EntityListAdministrationContent;
